import DateRangePicker from '../../modules/DateRangePicker';
export default class ServiceFilter {
    constructor() {
        this.currentFilters = {};
        this.page = 1;
        this.filterContainer = document.querySelector('[data-service-filter]');
        if (!this.filterContainer)
            return;
        this.servicesContainer = document.querySelector('[data-services]');
        this.paginationWrapper = document.querySelector('[data-pagination-wrapper]');
        this.filterInputs = this.filterContainer.querySelectorAll('[data-filter]');
        this.categoryButtons = this.filterContainer.querySelectorAll('[data-filter-category]');
        this.clearButton = document.querySelector('[data-clear-filters]');
        this.ajaxApiUrl = window.localize_script.admin_ajax;
        this.dateRangePicker = new DateRangePicker();
        this.initializeFromURL();
        this.addEventListeners();
        this.loadServices();
    }
    initializeFromURL() {
        const urlParams = new URLSearchParams(window.location.search);
        // Initialize regular filters
        this.filterInputs.forEach(input => {
            const filterName = input.getAttribute('data-filter');
            const value = urlParams.get(filterName);
            if (value) {
                input.value = value;
                this.currentFilters[filterName] = value;
            }
        });
        // Initialize category filter
        const categoryParam = urlParams.get('category');
        if (categoryParam) {
            this.currentFilters['category'] = categoryParam;
            this.updateCategoryButtonState(categoryParam);
        }
        this.updateClearButtonVisibility();
    }
    addEventListeners() {
        // Prevent default form submission and handle it with AJAX
        this.filterContainer.addEventListener('submit', (event) => {
            event.preventDefault();
            this.handleFilterChange();
        });
        this.filterInputs.forEach(input => {
            input.addEventListener('change', () => {
                this.handleFilterChange();
            });
        });
        // Category filter buttons
        this.categoryButtons.forEach(button => {
            button.addEventListener('click', () => {
                const category = button.getAttribute('data-filter-category');
                this.handleCategoryChange(category);
            });
        });
        this.clearButton.addEventListener('click', () => {
            this.clearFilters();
        });
        document.addEventListener('click', (event) => {
            const target = event.target;
            if (target.classList.contains('page-numbers') && !target.classList.contains('current')) {
                event.preventDefault();
                this.page = parseInt(target.textContent) || 1;
                this.loadServices();
            }
        });
    }
    handleCategoryChange(category) {
        if (category === 'all') {
            delete this.currentFilters['category'];
        }
        else {
            this.currentFilters['category'] = category;
        }
        this.updateCategoryButtonState(category);
        this.updateURL();
        this.updateClearButtonVisibility();
        this.page = 1;
        this.loadServices();
    }
    updateCategoryButtonState(activeCategory) {
        this.categoryButtons.forEach(button => {
            const category = button.getAttribute('data-filter-category');
            if (category === activeCategory || (activeCategory === 'all' && category === 'all') || (!activeCategory && category === 'all')) {
                button.classList.add('active');
            }
            else {
                button.classList.remove('active');
            }
        });
    }
    updateClearButtonVisibility() {
        const hasFilters = Object.keys(this.currentFilters).length > 0;
        if (hasFilters) {
            this.clearButton.style.display = 'block';
        }
        else {
            this.clearButton.style.display = 'none';
        }
    }
    handleFilterChange() {
        this.currentFilters = {};
        this.filterInputs.forEach(input => {
            const filterName = input.getAttribute('data-filter');
            if (input.value) {
                this.currentFilters[filterName] = input.value;
            }
        });
        this.updateURL();
        this.updateClearButtonVisibility();
        this.page = 1;
        this.loadServices();
    }
    clearFilters() {
        this.currentFilters = {};
        this.filterInputs.forEach(input => {
            input.value = '';
        });
        // Reset category buttons
        this.updateCategoryButtonState('all');
        if (this.dateRangePicker) {
            this.dateRangePicker.destroy();
            this.dateRangePicker = new DateRangePicker();
        }
        this.updateURL();
        this.updateClearButtonVisibility();
        this.page = 1;
        this.loadServices();
    }
    updateURL() {
        const url = new URL(window.location.href);
        url.search = '';
        Object.entries(this.currentFilters).forEach(([key, value]) => {
            if (value) {
                url.searchParams.set(key, value);
            }
        });
        window.history.pushState(null, '', url.toString());
    }
    loadInfo() {
        const loadInfo = this.servicesContainer.getAttribute('data-services').split(',');
        this.loadMoreInfo = {
            page: this.page,
            posts_per_page: parseInt(loadInfo[1]),
            max_pages: parseInt(loadInfo[2])
        };
    }
    loadServices() {
        this.loadInfo();
        const formData = new FormData();
        formData.append('action', 'filter_services');
        formData.append('lang', document.documentElement.lang.split('-')[0]);
        Object.entries(this.currentFilters).forEach(([key, value]) => {
            if (value) {
                formData.append(key, value);
            }
        });
        formData.append('page', this.page.toString());
        formData.append('posts_per_page', this.loadMoreInfo.posts_per_page.toString());
        const options = {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        };
        fetch(this.ajaxApiUrl, options)
            .then(response => response.json())
            .then(response => {
            if (response.success) {
                this.servicesContainer.innerHTML = response.data.html;
                this.paginationWrapper.innerHTML = response.data.pagination;
                document.dispatchEvent(new CustomEvent('lazyload:observe', { detail: this.servicesContainer }));
            }
            else {
                this.servicesContainer.innerHTML = '<div class="no-results"><p>' + response.data.message + '</p></div>';
                this.paginationWrapper.innerHTML = '';
            }
        })
            .catch(error => {
            console.error('Fetch error:', error);
            this.servicesContainer.innerHTML = '<div class="error"><p>Error loading services</p></div>';
        })
            .finally(() => {
            this.servicesContainer.classList.remove('has-loader');
        });
    }
}
